import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const DisciplineQuerySchema = PaginationRequestSchema.extend({
  name: z.string().optional(),
  createdFrom: z.string().optional(),
  createdTo: z.string().optional(),
});
export type DisciplineQueryDTO = z.infer<typeof DisciplineQuerySchema>;

const DisciplineBaseSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  description: z.string().optional(),
  color: z.string().optional(),
  sortOrder: z.number().optional().default(0),
  isSystem: z.boolean().optional().default(false),
  canDelete: z.boolean().optional().default(true),
  canEdit: z.boolean().optional().default(true),
});

export const UpdateDisciplineRequestSchema = DisciplineBaseSchema.partial();

export type UpdateDisciplineRequestDTO = z.infer<
  typeof UpdateDisciplineRequestSchema
>;

export const DisciplineResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  sortOrder: z.number(),
  isSystem: z.boolean(),
  canDelete: z.boolean(),
  canEdit: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DisciplineResponseDTO = z.infer<typeof DisciplineResponseSchema>;

export const DisciplinesPaginatedResponseSchema = PaginationResponseSchema(
  DisciplineResponseSchema,
);
export type DisciplinesPaginatedResponseDTO = z.infer<
  typeof DisciplinesPaginatedResponseSchema
>;
